


























import { listFactory } from '@/main/pages';
import { deleteButton, printButton } from '@/main/utils/tableOperations';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { store } from './store/list';
import { NAME } from './constants';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		DmsPdfDialog,
	},
	data() {
		return {
			dialog: {
				visible: false,
				fetchPdfProvider: null as Function | null,
				filter: {},
			},
		};
	},
	computed: {
		extraButtons(): {} {
			return {
				...deleteButton((e: any, cells: any) => this.deleteItem(cells[this.table!.cellNames!.idColumn])),
				...printButton((e: any, cells: any) => this.printRow(cells[this.table!.cellNames!.idColumn])),
			};
		},
	},
	methods: {
		async uzaverka() {
			this.startLoading();
			try {
				const { headers } = await apiProvider.uzaverkaPokladny(this.filter.PokladnaId);
				const [, id] = headers.location.split('=');
				if (this.makePrint) {
					this.showPdf(parseInt(id, 10));
				}
				// TODO: api call vraci cislo uzaverky, ktere bude potreba pro tisk
				this.filter.lastTimeUzav = (await apiProvider.getLastTimeUzav(this.filter.PokladnaId)).data;
				this.tableData();
			} finally {
				this.endLoading();
			}
		},
		pdfProvider(filter: { uzavId: number, platbaPzn: number[], detail: boolean }) {
			return apiProvider.getUzaverkaPokladny(filter);
		},
		async getUzavDate(pokladnaId: number) {
			this.filter.lastTimeUzav = (await apiProvider.getLastTimeUzav(pokladnaId)).data;
		},
		showPdf(uzavId: number) {
			this.dialog.filter = {
				uzavId,
				platbaPzn: this.ZpusobPlatbyId,
				detail: this.takeDetail,
			};
			this.dialog.fetchPdfProvider = this.pdfProvider;
			this.dialog.visible = true;
		},
		printRow(uzavId: number) {
			this.showPdf(uzavId);
		},
	},
});
